<template>
  <div class="ht-tab-wrap">
    <b-tabs class="ht-tab-menu wow move-up">
      <b-tab title="Background" active>
        <AboutUsSummary />
      </b-tab>
      <b-tab title="Our Drive">
        <OurDriveV2 />
      </b-tab>
      <b-tab title="Our mission">
        <OurMissionV2 />
      </b-tab>
      <b-tab title="Our Values">
        <OurValuesV2 />
      </b-tab>
      <b-tab title="Our Vision">
        <OurVisionV2 />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import OurDriveV2 from "./OurDriveV2";
import OurMissionV2 from "./OurMissionV2";
import OurValuesV2 from "./OurValuesV2";
import OurVisionV2 from "./OurVisionV2";
import AboutUsSummary from "@/components/AboutUsSummary";

export default {
  name: "TabOne",
  components: {
    AboutUsSummary,
    OurDriveV2,
    OurMissionV2,
    OurValuesV2,
    OurVisionV2,
  },
};
</script>
